import { Stack } from '@mantine/core';
import { ConditionalStep } from '@/types/automationSteps.ts';
import StepCommonFields from '@/pages/Editor/components/SharedFields/StepCommonFields.tsx';
import * as React from 'react';
import ConditionalFields from '@/pages/Editor/components/StepSidebar/StepForms/ConditionalStep/ConditionalFields.tsx';
import StepAdvancedConfigFields from '@/pages/Editor/components/SharedFields/StepAdvancedConfigFields.tsx';

type props = {
  step: ConditionalStep;
};

export function ConditionalForm({ step }: props) {
  return (
    <Stack gap="md">
      <StepCommonFields step={step} nameLabel={'Step Name'} />
      <ConditionalFields step={step} />
      {/*<OutputNameField step={step} />*/}
      <StepAdvancedConfigFields step={step} />
    </Stack>
  );
}
